import React, { FunctionComponent } from 'react';
import { ErrorMessage } from './ValidationError.style';

interface Props {
  error?: string | false;
}

const ValidationError: FunctionComponent<Props> = (props) => {
  if (!props.error) {
    return null;
  }

  return <ErrorMessage data-testid="validation-error">{props.error}</ErrorMessage>;
};

export default ValidationError;
